function setupEngravingSubmitHandler() {
  console.log('setupEngravingSubmitHandler running');

  // Use your form's unique ID to find it reliably
  // In Dawn, the ID is usually: "product-form-{{ section.id }}"
  // If you use a specific template, you may need to adjust this
  var productForm = document.getElementById('product-form-template--24548409377104__main');
  if (!productForm) {
    // Fallback to the standard Dawn form ID if custom ID not found
    productForm = document.getElementById('product-form-{{ section.id }}');
  }
  if (!productForm) {
    console.log('No product form found');
    return;
  }
  console.log('Product form found:', productForm);

  // Avoid duplicate handlers
  if (productForm.hasEngravingDebugHandler) {
    console.log('Handler already attached');
    return;
  }
  productForm.hasEngravingDebugHandler = true;
  console.log('Attaching submit handler');

  productForm.addEventListener('submit', function(e) {
    // Do NOT preventDefault unless you need to do async work
    // e.preventDefault();

    // 1. Check the template selection input
    var templateInput = document.getElementById('selected-engraving-template');
    if (templateInput) {
      console.log('[DEBUG] Template input found. Value:', templateInput.value);
    } else {
      console.log('[DEBUG] Template input NOT found');
    }

    // 2. Log all form data
    var formData = new FormData(productForm);
    for (var pair of formData.entries()) {
      console.log('[DEBUG] FormData:', pair[0], pair[1]);
    }

    // 3. Specifically check the engraving template property
    var templateProperty = formData.get('properties[Engraving Template]');
    if (templateProperty) {
      console.log('[DEBUG] Engraving Template property found:', templateProperty);
    } else {
      console.log('[DEBUG] Engraving Template property NOT found in form data');
    }

    // Let the form submit normally!
    // If you need to do async work (like html2canvas), use e.preventDefault() and submit after.
  });
}

// Run on DOM ready and when Shopify reloads sections
document.addEventListener('DOMContentLoaded', setupEngravingSubmitHandler);
document.addEventListener('shopify:section:load', setupEngravingSubmitHandler);
